import script from "./HeaderSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderSearch.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderSearch.vue?vue&type=style&index=0&id=baad7f4c&scoped=true&lang=css"
import "./HeaderSearch.vue?vue&type=style&index=1&id=baad7f4c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-baad7f4c"]])

export default __exports__